import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import {
  canCommentContentObjectList,
  canCreateContentObject,
  canManageContentObject,
  canReportContentObject,
  canRepostContentObjectList,
  canShareContentObject,
  canShareContentObjectList,
  isContentObjectAuthor,
} from '../permissions';

export const useContentObjectPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canCommentContentObjectList: bindViewer(canCommentContentObjectList),
      canCreateContentObject: bindViewer(canCreateContentObject),
      canManageContentObject: bindViewer(canManageContentObject),
      canReportContentObject: bindViewer(canReportContentObject),
      canRepostContentObjectList: bindViewer(canRepostContentObjectList),
      canShareContentObject: bindViewer(canShareContentObject),
      canShareContentObjectList: bindViewer(canShareContentObjectList),
      isContentObjectAuthor: bindViewer(isContentObjectAuthor),
    }),
    [bindViewer],
  );
};
